
export { globalAPI } from "/builds/dd3tech/wiggot/wiggot-web/packages/apis/new-apis/global-api.ts"